import { Button } from '@mui/material';

import ConcludeErrorsDialog from '../../../../common/components/concludeErrorsDialog/ConcludeErrorsDialog';
import { ONBOARDING_FOOTER_BUTTON_LABELS } from '../constants';
import ConcludeConfirmModal from './ConcludeConfirmModal';
import ConcludeSuccessModal from './ConcludeSuccessModal';

import type { ConcludeButtonViewProps } from './types';

export default function ConcludeButtonView({
  isSubmitting,
  isConfirmOpen,
  isSuccessOpen,
  errorPageLabels,
  readOnly,
  openConfirm,
  closeConfirm,
  confirmConclude,
  closeSuccess,
}: ConcludeButtonViewProps) {
  if (readOnly) return null;

  return (
    <>
      <Button disabled={isSubmitting} onClick={openConfirm} type="button" variant="contained">
        {ONBOARDING_FOOTER_BUTTON_LABELS.CONCLUDE}
      </Button>
      {errorPageLabels.length > 0 ? (
        <ConcludeErrorsDialog
          open={isConfirmOpen}
          pageLabels={errorPageLabels}
          onClose={closeConfirm}
        />
      ) : (
        <ConcludeConfirmModal
          open={isConfirmOpen}
          submitLoading={isSubmitting}
          onClose={closeConfirm}
          onSubmit={confirmConclude}
        />
      )}
      <ConcludeSuccessModal open={isSuccessOpen} onClose={closeSuccess} />
    </>
  );
}
